
export default ({
    data() {
        return {
            value1: '',
            value2: ''
        }
    },
    props: {
        text: {
            default: "11"
        }
    },
});
